<div class="card">
  <div class="card-header">
    <span>View Task Feedback</span>
  </div>
  <div [loadingOverlay]="isLoading" class="card-body">
    <div class="row">
      <div class="col-md-5 form-group">
        <label>Filter by Task ID</label>
        <input [(ngModel)]="taskIdFilter" (ngModelChange)="filterFeedback()"  type="text" class="form-control" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <app-table [items]="filteredFeedback">
          <ng-template #tableHeader>
            <tr>
              <th sort field="TaskId">Task ID</th>
              <th sort field="Task.TaskTypeEnum">Task Type</th>
              <th sort desc field="FeedbackTask.StatusDate">Review Date</th>
              <th sort field="Passed">Status</th>
              <th>Feedback Details</th>
            </tr>
          </ng-template>
          <ng-template #tableBody let-feedback>
            <tr>
              <td>{{feedback.TaskId}}</td>
              <td>{{displayTaskType(feedback.Task.TaskTypeEnum)}}</td>
              <td>{{feedback.FeedbackTask.StatusDate | dateText: 'M/DD/YYYY h:mm a'}}</td>
              <td>
                <div class="d-flex justify-content-between align-items-center">
                  <span [class.text-success]="feedback.Passed" [class.text-danger]="!feedback.Passed">{{feedback.Passed ? 'Approved' : 'Rejected'}}</span>
                  <span class="cursor-pointer text-muted d-flex gap-1 align-items-center" [title]="expandedFeedbackIds.has(feedback.TaskFeedbackId) ? 'Hide Feedback' : 'View Feedback'" (click)="toggleFeedback(feedback.TaskFeedbackId)">
                    <i class="fa-regular fa-note-sticky"></i>
                    <i class="fa-solid" [class.fa-chevron-down]="!expandedFeedbackIds.has(feedback.TaskFeedbackId)" [class.fa-chevron-up]="expandedFeedbackIds.has(feedback.TaskFeedbackId)"></i>
                  </span>
                </div>
              </td>
              <td>
                @if (hasDetails(feedback)) {
                  <button type="button" class="btn btn-primary btn-sm" (click)="show(feedback)">
                    View Details <span class="caret"></span>
                  </button>
                } @else {
                  <button type="button" class="btn btn-secondary btn-sm" disabled>Not Available</button>
                }
              </td>
            </tr>
            @if (expandedFeedbackIds.has(feedback.TaskFeedbackId)) {
              <tr>
                <td colspan="5">
                  <span [innerHTML]="feedback.Feedback ? feedback.Feedback : noFeedback"></span>
                </td>
              </tr>
              <tr style="height: 12px"><td colspan="5" class="p-0 border-0"></td></tr>
            }
          </ng-template>
        </app-table>
      </div>
    </div>
  </div>
</div>
